import TemplateView from '../../../TemplateView'
import SettingsInfoHeader from './SettingsInfoHeader'
import SettingsInfoContainer from './SettingsInfoContainer'

export default class DARSetting extends TemplateView {
    constructor({
        headerContent,
        descriptionContent,
        extraClass = '',
        onCollapseChanged = (collapsed) => {},
    }) {
        super()

        this.params = {
            headerContent,
            descriptionContent,
            extraClass,
            onCollapseChanged,
        }

        this.state = {
            collapsed: true,
        }

        this.onStatePropertyChanged('collapsed', (collapsed) => {
            this.header.setState({collapsed})
            this.description.setState({collapsed})
        })
    }

    templateHtml() {
        return '<div class="darSetting <%=extraClass%>"></div>'
    }

    afterRender() {
        this.header = new SettingsInfoHeader({
            content: this.params.headerContent,
            onCollapseChanged: this.params.onCollapseChanged,
        }).init(this.$el)
        this.description = new SettingsInfoContainer({
            content: this.params.descriptionContent
        }).init(this.$el)

        this.renderInitialState()
    }

    templateModel() {
        return {
            extraClass: this.params.extraClass,
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/components/DARSetting.js